import { Button } from '@volue/wave-react';
import React from 'react';

import { InlineNotification } from '@/features/execute-calculation-set/components/Calculation/InlineNotification';
import { useActions, useAppState } from '@/overmind';

export function LoadingCalculationSetsErrorCard() {
  const setCalculationTacticSet = useActions().calculation.loadCalculationSets;
  const restartApp = useActions().internal.restartApp
  const hasVolueIdentityTokenExpired = useAppState().auth.matches("AUTHENTICATED")?.hasVolueAccessTokenExpired

  if (hasVolueIdentityTokenExpired) {
    return (
      <InlineNotification
        type="ERROR"
        content="Your session has expired."
        actionButtons={[
          <Button className="mRn" onClick={restartApp}>
            {'Restart application'}
          </Button>
        ]}
      />
    );
  }
  return (
    <InlineNotification
      type="ERROR"
      content="Could not fetch available calculation sets"
      actionButtons={[
        <Button className="mRn" onClick={setCalculationTacticSet}>
          {'Retry'}
        </Button>
      ]}
    />
  );
}
